import { render } from "./WpeWysiwyg.vue?vue&type=template&id=054553cb"
import script from "./WpeWysiwyg.vue?vue&type=script&lang=js"
export * from "./WpeWysiwyg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeWysiwyg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "054553cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('054553cb', __exports__)) {
    api.reload('054553cb', __exports__)
  }
  
  module.hot.accept("./WpeWysiwyg.vue?vue&type=template&id=054553cb", () => {
    api.rerender('054553cb', render)
  })

}


export default __exports__